"use strict";

import angular from "angular";

import tippy from "tippy.js";

const name = "tippyTooltip";
const factory = [
    () => ({
        restrict: "A",
        scope: {
            tippyTooltip: "@"
        },
        link: ($scope, $elem, $attr) => {
            const context = tippy($elem[0], {
                content: $scope.tippyTooltip,
                placement: "bottom",
                allowHTML: true,
                theme: "default",
                onShow(instance) {
                    if (!instance.props.content.trim()) {
                        return false;
                    }
                }
            });
            $scope.$watch(
                () => $scope.tippyTooltip,
                (newValue, oldValue) => {
                    context.setContent(newValue);
                }
            );
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
